import { useEffect } from "react";
import { useLocation } from "react-router";

/** Remonte en haut de page à chaque changement de route (évite de garder le scroll de la page précédente). */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
